
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __appWithI18n from 'next-translate/appWithI18n'
// @ts-ignore
    
//@ts-nocheck
import "@radix-ui/themes/styles.css";
import "../styles/globals.css";

import { ThemeProvider } from "next-themes";

import { DocumentCheckIcon, FolderIcon, HomeIcon, TicketIcon } from "@heroicons/react/24/outline";

import { MantineProvider } from "@mantine/core";
import { Theme } from "@radix-ui/themes";
import { useRouter } from "next/router";
import { QueryClient, QueryClientProvider } from "react-query";

import { SessionProvider, useUser } from "../store/session";

import React from "react";

import AdminLayout from "../layouts/adminLayout";
import NewLayout from "../layouts/newLayout";
import NoteBookLayout from "../layouts/notebook";
import PortalLayout from "../layouts/portalLayout";
import Settings from "../layouts/settings";
import ShadLayout from "../layouts/shad";
import GlobalShortcut from "@/shadcn/block/GlobalShortcut";
import { Toaster } from "@/shadcn/ui/toaster";

import { SidebarProvider } from "@/shadcn/ui/sidebar";

const queryClient = new QueryClient();

function Auth({ children }: any) {
    const { loading, user } = useUser();

    React.useEffect(() => {
        if (loading) return;
    }, [user, loading]);

    if (user) {
        return children;
    }

    return <div className="flex items-center justify-center h-screen text-green-600"></div>;
}

function MyApp({ Component, pageProps: { session, ...pageProps } }: any) {
    const router = useRouter();

    if (router.asPath.slice(0, 5) === "/auth") {
        return (
            <ThemeProvider attribute="class" defaultTheme="light">
                <Component {...pageProps} />
                <Toaster />
            </ThemeProvider>
        );
    }

    if (router.pathname.includes("/admin")) {
        return (
            <SessionProvider>
                <ThemeProvider attribute="class" defaultTheme="light">
                    <Theme>
                        <QueryClientProvider client={queryClient}>
                            <Auth>
                                <AdminLayout>
                                    <Component {...pageProps} />
                                    
                                </AdminLayout>
                            </Auth>
                        </QueryClientProvider>
                        <Toaster />
                    </Theme>
                </ThemeProvider>
            </SessionProvider>
        );
    }

    if (router.pathname.includes("/settings")) {
        return (
            <SessionProvider>
                <ThemeProvider attribute="class" defaultTheme="light">
                    <Theme>
                        <QueryClientProvider client={queryClient}>
                            <Auth>
                                <ShadLayout>
                                    <Settings>
                                        <Component {...pageProps} />
                                    </Settings>
                                </ShadLayout>
                            </Auth>
                        </QueryClientProvider>
                        <Toaster />
                    </Theme>
                </ThemeProvider>
            </SessionProvider>
        );
    }

    if (router.pathname.startsWith("/portal") || /^\/[^/]+\/portal/.test(router.pathname)) {
        return (
            <SessionProvider>
                <Theme>
                    <QueryClientProvider client={queryClient}>
                        <Auth>
                            <PortalLayout>
                                <Component {...pageProps} />
                            </PortalLayout>
                        </Auth>
                    </QueryClientProvider>
                    <Toaster />
                </Theme>
            </SessionProvider>
        );
    }

    if (router.pathname === "/onboarding") {
        return (
            <SessionProvider>
                <Component {...pageProps} />
                <Toaster />
            </SessionProvider>
        );
    }

    if (/^\/[^/]+\/ticket/.test(router.pathname)) {
        return (
            <>
                <Component {...pageProps} />
                <Toaster />
            </>
        );
    }

    return (
        <SessionProvider>
            <ThemeProvider attribute="class" defaultTheme="light">
                <Theme>
                    <QueryClientProvider client={queryClient}>
                        <Auth>
                            <ShadLayout>
                                <Component {...pageProps} />
                            </ShadLayout>
                        </Auth>
                    </QueryClientProvider>
                </Theme>
                <Toaster />
            </ThemeProvider>
        </SessionProvider>
    );
}

const __Page_Next_Translate__ = MyApp;


// @ts-ignore
    export default __appWithI18n(__Page_Next_Translate__, {
// @ts-ignore
      ...__i18nConfig,
// @ts-ignore
      isLoader: true,
// @ts-ignore
      skipInitialProps: true,
// @ts-ignore
      loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
    });
// @ts-ignore
  